import { useState, useEffect, useCallback } from "react"

const STORAGE_KEY = "tree_sort"

const DEFAULT_SORT = {
  field: null,
  direction: "desc",
}

export const useTreeSort = () => {
  const [sort, setSort] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      return stored ? { ...DEFAULT_SORT, ...JSON.parse(stored) } : DEFAULT_SORT
    } catch {
      return DEFAULT_SORT
    }
  })

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(sort))
    } catch (error) {
      console.error("Failed to save sort:", error)
    }
  }, [sort])

  const updateSort = useCallback((field, direction) => {
    setSort({ field, direction })
  }, [])

  const clearSort = useCallback(() => {
    setSort(DEFAULT_SORT)
  }, [])

  return {
    treeSort: sort,
    updateTreeSort: updateSort,
    clearTreeSort: clearSort,
  }
}
